module.exports = __webpack_public_path__ + "static/media/PP Alex Lau (Fellowship)-min.91cb2e90.jpeg";